import Vue from 'vue'
import Vuex from 'vuex'
const FONT_SIZE_MORE = 'FONT_SIZE_MORE'
const FONT_SIZE_LESS = 'FONT_SIZE_LESS'
const SET = 'SET';
const ASSIGN = 'ASSIGN';
const ADD = 'ADD';
const SET_SNACKBAR = 'SET_SNACKBAR';
const LOGOUT = 'LOGOUT';
Vue.use(Vuex)

import CA_SP from './modules/CA_SP/store.js'

const defaultStore = {
  state: {
    router:null,
    menuLateral: [],
    menuLateralIndice: {},
    access:{
      time:0,
      val:null,
    },
    requests: { get_export:{}, put: {}, patch: {}, get: {}, gets: {}, post: {}, post_m:{}, delete :{}, getsSimple: {}, put_no_id:{},patch_restore:{} },
    navegations: {},
    endpoints: [],//no estaba en la otra version, agregado por encontre raro q no lo estuviese
    $socket:()=>{},
    $socket_info:{
      joined_rooms:[],
    },
    bs:null,
    null_token:false,// para probar fallas en token
    incompleteItems:[],
    /* ----------------------------- */
    dark:false,
    title: '',
    subtitle: '',
    users: [],
    fontSize: 15,
    session : {
      refresh:null,
      access: false,
      user: {},
    },
    snackbar: {
      message: '',
      show: false,
      color: 'success',
      right: false,
      left: false,
      top: true,
      timeout: 3000,
      'multi-line': false,
      clearable: false,
    },
    progress: {
      message: '',
      show: false,
      color: '#ffffff'
    },
    //
    specialities: [],
    listImpactedAreas: [],
    ebits: [],
    organizations: [],
    criticalAssets: [],
    spareParts: [],
    criticalAssetsDeleted: [],
    sparePartsDeleted: [],
    standards: [],
    reported_actions:[],
    requestStatus: [
      { rq: false, status: false, ticking: false, name: 'reported_actions',  message: 'reported_actions' },
      { rq: false, status: false, ticking: false, name: 'criticalAssets',  message: 'criticalAssets' },
      { rq: false, status: false, ticking: false, name: 'users',  message: 'usuarios' },
      { rq: false, status: false, ticking: false, name: 'ac_with_ptr_files', message: 'ac_with_ptr_files'},
      { rq: false, status: false, ticking: false, name: 'standards', message: 'standards'},
      { rq: false, status: false, ticking: false, name: 'actionTrackerIssues', message: 'actionTrackerIssues'},
      { rq: false, status: false, ticking: false, name: 'organizations', message: 'organizations'},
      { rq: false, status: false, ticking: false, name: 'impacted_areas', message: 'impacted_areas'},
      { rq: false, status: false, ticking: false, name: 'pwoCancelleds', message: 'pwoCancelleds'},
      { rq: false, status: false, ticking: false, name: 'pwoOverdues', message: 'pwoOverdues'},
      { rq: false, status: false, ticking: false, name: 'pwoCompliances', message: 'pwoCompliances'},
      { rq: false, status: false, ticking: false, name: 'specialities', message: 'specialities'},
      { rq: false, status: false, ticking: false, name: 'spareParts', message: 'spareParts'},
      { rq: false, status: false, ticking: false, name: 'trackActivities', message: 'trackActivities'},
      { rq: false, status: false, ticking: false, name: 'userAssets', message: 'userAssets'},
      { rq: false, status: false, ticking: false, name: 'permissions', message: 'permissions'},
      { rq: false, status: false, ticking: false, name: 'profiles', message: 'profiles'},
      { rq: false, status: false, ticking: false, name: 'roles', message: 'roles'},
      { rq: false, status: false, ticking: false, name: 'listImpactedAreas', message: 'listImpactedAreas'},
      { rq: false, status: false, ticking: false, name: 'ebits', message: 'ebits'},
      { rq: false, status: false, ticking: false, name: 'actions', message: 'actions'},
      { rq: false, status: false, ticking: false, name: 'data_action_tracker_types', message: 'data_action_tracker_types'},
      { rq: false, status: false, ticking: false, name: 'critical_asset_by_organization', message: 'critical_asset_by_organization'},

      { rq: false, status: false, ticking: false, name: 'critical_asset_by_status_value', message: 'critical_asset_by_status_value'},
      { rq: false, status: false, ticking: false, name: 'critical_asset_by_status_number', message: 'critical_asset_by_status_number'},
      { rq: false, status: false, ticking: false, name: 'dashboard_metrics_percentage', message: 'dashboard_metrics_percentage'},

      { rq: false, status: false, ticking: false, name: 'dashboard_actions_priority_actions', message: 'dashboard_actions_priority_actions'},
      { rq: false, status: false, ticking: false, name: 'dashboard_actions_priority', message: 'dashboard_actions_priority'},
      { rq: false, status: false, ticking: false, name: 'kri_pivot_table', message: 'kri_pivot_table'},
      { rq: false, status: false, ticking: false, name: 'fiscal_years', message: 'fiscal_years'},
      { rq: false, status: false, ticking: false, name: 'paginated_action_tracker_issues', message: 'paginated_action_tracker_issues'},
      { rq: false, status: false, ticking: false, name: 'dashboard_metrics_report_table', message: 'dashboard_metrics_report_table'},
      { rq: false, status: false, ticking: false, name: 'dashboard_metrics_specific_headers', message: 'dashboard_metrics_specific_headers'},
      { rq: false, status: false, ticking: false, name: 'file_types', message: 'file_types'},
      { rq: false, status: false, ticking: false, name: 'asset_class', message: 'asset_class'},
      { rq: false, status: false, ticking: false, name: 'limit', message: 'limit'},
      { rq: false, status: false, ticking: false, name: 'simulations_ca', message: 'simulations_ca'},
      { rq: false, status: false, ticking: false, name: 'simulations_sp', message: 'simulations_sp'},
     
    ],
    actionTrackerIssues: [],
    pwoCancelleds: [],
    pwoOverdues: [],
    pwoCompliances: [],
    pendingWfs: [],
    myManagementPendingTotal: 0,
    myManagementTablesRefreshTick: 0,
    accessRequesting: false,
    trackActivities: [],
    userAssets: [],
    permissions: [],
    profiles: [],
    roles: [],
    prtFiles: {
      count:0,
      next: null,
      previous: null,
      results:[],
    },
    prtNavegation:{
      page: 1,
      count: 0,
      page_size: 10,
      pages: 0,
    },
    KRINavegation:{
      page: 1,
      count: 0,
      page_size: 10,
      pages: 0,
    },
    actions: [],
    KRI: {
      count:0,
      next: null,
      previous: null,
      results:[],
    },
    data_action_tracker_types:[],
    publicFile1: {},
    critical_asset_by_organization: {total: 0},
    dashboard_metrics_percentage:[],
    dashboard_actions_priority_actions:[],
    dashboard_actions_priority:[],
    kri_pivot_table:[],
    kri_report_table:[],
    kri_summary_table:[],
    fiscal_years:[],
    current_fiscal_year:{year:0},
    sheet_update_metrics: null,
    sheet_update_action_tracker_issues: null,
    sheet_update_actions: null,
    sheet_update_kri: null,
    paginated_action_tracker_issues:{},
    dashboard_metrics_report_table:[],
    dashboard_metrics_specific_headers:[],
    getWorkflowNull:false,
    file_types:[],
    asset_class:[],
    bowties:[],
    limit:null,
    simulations_ca:[],
    simulations_sp:[],
    simulations_join_ca_with_scas:[],
    dialogs:[],
  },
  getters: {
    menuLateral: state => state.menuLateral,
    menuLateralIndice: state => state.menuLateralIndice,
    access: state => state.access,
    requests: state => state.requests,
    endpoints: state => state.endpoints,
    navegations: state => state.navegations,
    $socket: state => state.$socket,
    $socket_info: state => state.$socket_info,
    bs: state => state.bs,
    null_token: state => state.null_token,
    incompleteItems: state => state.incompleteItems,
    /* --------------------- */
    title: state => state.title,
    subtitle: state => state.subtitle,
    standardRisks: state => state.standardRisks,
    users: state => state.users,
    areas: state => state.areas,
    faenas: state => state.faenas,
    fontSize: state => state.fontSize,
    session: state => state.session,
    tags: state => state.tags,
    epps: state => state.epps,
    documents: state => state.documents,
    crud: state => state.crud,
    snackbar: state => state.snackbar,
    progress: state => state.progress,
    procedureRisks: state => state.procedureRisks,
    procedures: state => state.procedures,
    taxonomyManagementAreas: state => state.taxonomyManagementAreas,
    taxonomySubAreas: state => state.taxonomySubAreas,
    taxonomyHeads: state => state.taxonomyHeads,
    empresas: state => state.empresas,
    //////
    specialities: state => state.specialities,
    listImpactedAreas: state => state.listImpactedAreas,
    ebits: state => state.ebits,
    organizations: state => state.organizations,
    criticalAssets: state => state.criticalAssets,
    spareParts: state => state.spareParts,
    standards: state => state.standards,
    requestStatus: state => state.requestStatus,
    actionTrackerIssues: state => state.actionTrackerIssues,
    pwoCancelleds: state => state.pwoCancelleds,
    pwoOverdues: state => state.pwoOverdues,
    pwoCompliances: state => state.pwoCompliances,
    accessRequesting: state => state.accessRequesting,
    pendingWfs: state => state.pendingWfs,
    myManagementPendingTotal: state => state.myManagementPendingTotal,
    myManagementTablesRefreshTick: state => state.myManagementTablesRefreshTick,
    trackActivities: state => state.trackActivities,
    userAssets: state => state.userAssets,
    permissions: state => state.permissions,
    profiles: state => state.profiles,
    roles: state => state.roles,
    criticalAssetsDeleted: state => state.criticalAssetsDeleted,
    sparePartsDeleted: state => state.sparePartsDeleted,
    prtFiles: state => state.prtFiles,
    prtNavegation: state => state.prtNavegation,
    actions: state => state.actions,
    KRINavegation: state => state.KRINavegation,
    KRI: state => state.KRI,
    data_action_tracker_types: state => state.data_action_tracker_types,
    publicFile1: state => state.publicFile1,
    critical_asset_by_organization: state => state.critical_asset_by_organization,
    dashboard_metrics_percentage: state => state.dashboard_metrics_percentage,
    dashboard_actions_priority_actions: state => state.dashboard_actions_priority_actions,
    dashboard_actions_priority: state => state.dashboard_actions_priority,
    kri_pivot_table: state => state.kri_pivot_table,
    kri_report_table: state => state.kri_report_table,
    kri_summary_table: state => state.kri_summary_table,
    fiscal_years: state => state.fiscal_years,
    current_fiscal_year: state => state.current_fiscal_year,
    sheet_update_metrics: state => state.sheet_update_metrics,
    sheet_update_action_tracker_issues: state => state.sheet_update_action_tracker_issues,
    sheet_update_actions: state => state.sheet_update_actions,
    sheet_update_kri: state => state.sheet_update_kri,
    paginated_action_tracker_issues: state => state.paginated_action_tracker_issues,
    dashboard_metrics_report_table: state => state.dashboard_metrics_report_table,
    dashboard_metrics_specific_headers: state => state.dashboard_metrics_specific_headers,
    getWorkflowNull: state => state.getWorkflowNull,
    file_types: state => state.file_types,
    asset_class: state => state.asset_class,
    bowties: state => state.bowties,
    limit: state => state.limit,
    dark: state => state.dark,
    reported_actions: state => state.reported_actions,
    simulations_ca: state => state.simulations_ca,
    simulations_sp: state => state.simulations_sp,
    simulations_join_ca_with_scas: state => state.simulations_join_ca_with_scas,
    dialogs: state => state.dialogs,
  },

  actions: {
    requestStatusReset({state}, name) {
      const rq = state.requestStatus.find(rq => rq.name === name);
      if (rq) {
        rq.rq = false;
        rq.status = false;
        rq.ticking = false;
      } else {
        console.error('no se encontro rq con ese nombre -> '+name)
      }
    },
    setProgress({commit}, val) {
      val.color = '#ffffff';
      commit(SET, {key: 'progress', val})
    },
    setSnackbar({commit}, val) {
      val.show = true;
      val.right = !!val.right;
      val.left = !!val.left;
      val.top = !!val.top || true; // por defecto
      if(val.class === 'warning') {
        val.class = `snack_${val.class}`;
        val.right = true;
        val.color = '#ffffff'
        val.icon = 'warning'
      }
      if(val.class === 'success') {
        val.class = `snack_${val.class}`;
        val.right = true;
        val.color = '#ffffff'
        val.icon = 'done'
      }
      if(val.class === 'error') {
        val.class = `snack_${val.class}`;
        val.right = true;
        val.color = '#ffffff'
        val.icon = 'cancel'
      }
      if (val.timeout === undefined) val.timeout = 3000;
      if (!val['multi-line']) val['multi-line'] = false;
      if (!val.clearable) val.clearable = false;
      
      commit(SET, {key: 'snackbar', val})
    },
    add({commit}, {key, val}) {
      commit(ADD, {key, val})
    },
    fontSizeMore({ commit }){
      commit(FONT_SIZE_MORE);
    },
    fontSizeLess({ commit }){
      commit(FONT_SIZE_LESS);
    },
    set({ commit }, {key, val}) {
      commit(SET, {key, val});
    },
    assign({ commit }, {key, val}) {
      commit(ASSIGN, {key, val});
    },
    logout({ commit, state }) {
      if (!state.session.token) {
        localStorage.clear();
        commit(LOGOUT);
      } // if
    },
    open_dialog({ commit }, key) {
      commit('OPEN_DIALOG', key);
    },
    close_dialog({ commit }, key) {
      commit('ClOSE_DIALOG', key);
    },
    refreshMyManagementPendingTotal({ state, dispatch }) {
      const user = state.session?.user || {};
      if (!user.is_ai_business_partner) {
        dispatch('set', { key: 'myManagementPendingTotal', val: 0 });
        return Promise.resolve();
      }
      const req = state.requests?.get?.['my_management/pending_summary'];
      if (!req) return Promise.resolve();
      return req()
        .then((data) => {
          if (data && typeof data.total === 'number') {
            dispatch('set', { key: 'myManagementPendingTotal', val: data.total });
          }
        })
        .catch(() => {});
    },
    refreshMyManagementPendingViews({ state, dispatch }) {
      dispatch('refreshMyManagementPendingTotal');
      dispatch('set', {
        key: 'myManagementTablesRefreshTick',
        val: state.myManagementTablesRefreshTick + 1,
      });
    },
  },
  mutations: {
    ['OPEN_DIALOG'](state, key) {
      if (!key) return console.error('se requiere un id para abrir un dialogo');
      if (state.dialogs.indexOf(key) != -1) return console.warn(`condición para abrir dialogo ${key} ya se habia cumplido`);
      state.dialogs.push(key);
    },
    ['ClOSE_DIALOG'](state, key) {
      //if (!key) return console.error('se requiere un id para cerrar un dialogo');
      if (!key) return state.dialogs.splice(0,state.dialogs.length);
      if (state.dialogs.indexOf(key) === -1) return console.warn(`dialogo ${key} ya se habia cerrado`);
      state.dialogs.splice(state.dialogs.indexOf(key),1);
    },
    
    [LOGOUT](state) {
      state.session.refresh = null;
      state.session.access = false;
      state.session.user = {};
    },
    [SET_SNACKBAR](state, snackbar) {
      state.snackbar = {...snackbar};
    },
    [ADD](state, {key, val}) {
      state[key].push(val);
    },
    [FONT_SIZE_MORE](state) {
      state.fontSize++;
    },
    [FONT_SIZE_LESS](state) {
      state.fontSize--;
    },
    [SET](state, {key, val}) {
      state[key] = val;
    },
    [ASSIGN](state, {key, val}) {
      Object.assign(state[key], val)
    },
  },
}

const store = {};
['actions', 'state', 'getters', 'mutations'].forEach(
  key => store[key] = Object.assign(
    defaultStore[key],
    CA_SP[key],
  )
)
//modules de vue store no funciona tan bien como hacerle merge en un obj y darselo como un todo
export default new Vuex.Store(store);
